const syncDocumentDirectoryAssetPersist = async () => {};
export default syncDocumentDirectoryAssetPersist;
